import { Box, Link, Toolbar, Typography } from "@mui/material";
import alliedLogo from "../../images/allied_logo.svg";
import infoOutlinedThinIcon from "../../images/info_outlined_thin.svg";
import { MatcherInvitationContext } from "../../shared/types";
import { getInviteStatusCopy } from ".";

export const InvitationDisplay = ({
  matcherInvitationContext,
  isInvitationAccepted,
  isLinkExpired,
}: {
  matcherInvitationContext?: MatcherInvitationContext | null;
  isInvitationAccepted?: boolean;
  isLinkExpired: boolean;
}) => {
  const { title, body } = getInviteStatusCopy({
    isLinkExpired,
    isInvitationAccepted,
    matcherInvitationContext,
  });

  return (
    <>
      <Toolbar
        sx={{
          "&.MuiToolbar-root": {
            height: 72,
            px: "18px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.14)",
          },
        }}
      >
        <Box component="img" src={alliedLogo} alt="Allied Universal" />
      </Toolbar>

      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          minHeight: "calc(100vh - 72px)",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Box sx={{ maxWidth: 400, textAlign: "center" }}>
          <Box mb={2} component="img" src={infoOutlinedThinIcon} alt="Info" />

          <Typography
            sx={{
              color: "#000000B8",
              fontSize: 18,
              fontWeight: 600,
              mb: 2,
            }}
          >
            {title}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#000000B8",
              lineHeight: "22px",
              mb: 2,
              textAlign: "left",
            }}
          >
            {body}
          </Typography>

          <Link
            href="https://jobs.aus.com"
            target="_blank"
            rel="noreferrer"
            underline="hover"
            sx={{
              fontSize: 14,
              color: "#007AFF",
              textDecoration: "underline",
            }}
          >
            AUS Jobs
          </Link>
        </Box>
      </Box>
    </>
  );
};
